"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeDuplicatePrimitives = removeDuplicatePrimitives;
function removeDuplicatePrimitives(arr) {
    return [...new Set(arr)];
}
//# sourceMappingURL=removeDuplicatePrimitives.js.map